import {FormikProps} from 'formik';
import {LoginAsCustomerFormValues} from '../../../interfaces/login';
import LoginAsCustomerForm from './LoginAsCustomerForm';

interface LoginAsCustomerFormLogicProps {
    formik: FormikProps<LoginAsCustomerFormValues>;
}

const LoginAsCustomerFormLogic = ({formik}: LoginAsCustomerFormLogicProps): JSX.Element | null => {
    return <LoginAsCustomerForm config={formik} />;
};

export default LoginAsCustomerFormLogic;
